var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAbsoluteURL)?_c('router-link',{class:_vm.className,attrs:{"to":_vm.localizedUrl + _vm.url,"target":_vm.target}},[_vm._t("default")],2):_c('a',{class:_vm.className,attrs:{"href":_vm.url,"target":_vm.target}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }